import styled, { css } from "styled-components";
import { DIAGNOSTICS_MEDIA } from "@/constants/diagnostics";

export const StyledDiagnosticsSection = styled.div<{ $active?: boolean, $isExclusive?: boolean, $height?: number }>`
  padding: var(--spacing-lg);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  transition: opacity var(--transition-fast);
  ${({ $active, $isExclusive }) => $active ? '' : css`
    opacity: ${$isExclusive ? 0 : 0.3};
    pointer-events: none;
  `}
  ${({ $height, $active }) => css`
    @media ${DIAGNOSTICS_MEDIA.sm} {
      padding: var(--spacing-md) 0;
      max-height: ${$height}px;
      overflow-y: auto;
      ${$active ? '' : css`
      opacity: 0;
      pointer-events: none;
    `}
  `}
`;

export const StyledDiagnosticsSectionContent = styled.div`
  --width: 1054px;
  @media ${DIAGNOSTICS_MEDIA.md} {
    --width: 100%;
    padding: 0 var(--spacing-md);
  }
  @media ${DIAGNOSTICS_MEDIA.sm} {
    text-align: center;
    .hidden-sm {
      display: none;
    }
  }
  max-width: var(--width);
  flex: 1 0 var(--width);
  position: relative;
  .section-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: var(--spacing-lg);
    @media ${DIAGNOSTICS_MEDIA.sm} {
      flex-direction: column;
    }
  }
  .section-content {
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-lg);
    @media ${DIAGNOSTICS_MEDIA.md} {
      max-width: 100%;
      flex: 1;
    }
    @media ${DIAGNOSTICS_MEDIA.sm} {
      gap: var(--spacing-sm);
      order: 2;
      align-items: center;
      width: 100%;
    }
  }
  .section-image {
    min-width: 284px;
    img {
      width: 284px;
      height: 284px;
      object-fit: contain;
    }
    @media ${DIAGNOSTICS_MEDIA.sm} {
      order: 1;
      max-width: 100%;
      width: 100%;
      text-align: center;
      img {
        width: 100%;
        height: auto;
        max-height: 200px;
        margin: 0 auto;
      }
    }
  }
  .section-frame {
    --width: 340px;
    @media ${DIAGNOSTICS_MEDIA.sm} {
      --width: 100%;
      &.padding-sm-large {
        margin: var(--spacing-lg) 0;
      }
    }
    flex: 0 0 var(--width);
    width: var(--width);
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12);
    border-radius: var(--radius-md);
    padding: var(--spacing-md);
    h4 {
      text-align: center;
      font-size: var(--font-size-md);
      font-weight: 600;
      color: var(--color-text);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: var(--spacing-sm);
      &.section-frame-title-with-buttons {
        justify-content: space-between;
        .section-frame-title-buttons {
          display: flex;
          gap: var(--spacing-sm);
          button {
            min-width: unset;
            border: 1px solid var(--color-border);
            border-radius: var(--radius-md);
            padding: var(--spacing-xs) var(--spacing-sm);
            font-size: var(--font-size-sm);
            font-weight: 600;
            color: var(--color-text);
            cursor: pointer;
            transition: all var(--transition-fast);
            &:hover:not(:disabled) {
              background-color: var(--color-border);
            }
            &:disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }
          }
        }
      }
    }
    video {
      width: 100%;
      height: 150px;
      object-fit: contain;
      margin: var(--spacing-md) 0;
      @media ${DIAGNOSTICS_MEDIA.sm} {
        height: 130px;
      }
    }
    .diagnostics-audio-device {
      margin: var(--spacing-md) 0;
      p {
        display: flex;
        align-items: center;
        gap: var(--spacing-sm);
        font-size: var(--font-size-sm);
      }
      select:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
  h2 {
    font-size: var(--font-size-xxl);
    font-weight: 600;
    color: var(--color-text);
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    @media ${DIAGNOSTICS_MEDIA.sm} {
      justify-content: center;
      width: 100%;
    }
  }
  p {
    padding-bottom: var(--spacing-sm);
    @media ${DIAGNOSTICS_MEDIA.sm} {
      padding-bottom: var(--spacing-xs);
    }
  }
  ul {
    padding-left: 20px;
    li {
      padding-bottom: var(--spacing-sm);
      @media ${DIAGNOSTICS_MEDIA.sm} {
        padding-bottom: var(--spacing-xs);
      }
    }
    @media ${DIAGNOSTICS_MEDIA.sm} {
      text-align: left;
    }
  }
  button {
    min-width: 207px;
  }
`;
